import { render, staticRenderFns } from "./charging-config-send-log.vue?vue&type=template&id=70436e96&scoped=true&"
import script from "./charging-config-send-log.vue?vue&type=script&lang=js&"
export * from "./charging-config-send-log.vue?vue&type=script&lang=js&"
import style0 from "./charging-config-send-log.vue?vue&type=style&index=0&id=70436e96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70436e96",
  null
  
)

export default component.exports